export const customerState = {
  selectCustomer: "",
  customerCategory: "",
  customerCode: "",
  customerName: "",
  status: "",
  priceCode: "",
  repName: "",
  repCode: "",
  remarks: "",
  creditLimit: "",
  creditPeriod: "",
  Balance: "",
  customerStatus: "",

  // status
  selectCustomerStatus: "unchecked",
  customerCategoryStatus: "unchecked",
  creditLimitStatus: "unchecked",
  creditPeriodStatus: "unchecked",
  customerCodeStatus: "unchecked",
  customerNameStatus: "unchecked",
  BalanceStatus: "unchecked",
  statusStatus: "unchecked",
  priceCodeStatus: "unchecked",
  repNameStatus: "unchecked",
  repCodeStatus: "unchecked",
  remarksStatus: "unchecked",
  customerStatusStatus: "unchecked",
};

export const customerStateMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;

  switch (inputName) {
    case "selectCustomer": {
      if (value) {
        return {
          ...state,
          selectCustomer: value,
          selectCustomerStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          selectCustomer: "",
          selectCustomerStatus: "unchecked",
        };
      }
    }
    case "customerStatus": {
      if (value) {
        return {
          ...state,
          customerStatus: value,
          customerStatusStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          customerStatus: "",
          customerStatusStatus: "unchecked",
        };
      }
    }
    case "repCode": {
      if (value) {
        return {
          ...state,
          repCode: value,
          repCodeStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          repCode: "",
          repCodeStatus: "unchecked",
          repName: "",
          repNameStatus: "unchecked",
        };
      }
    }

    case "remarks": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          remarks: value,
          remarksStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          remarks: "",
          remarksStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          remarks: value,
          remarksStatus: "error",
        };
      }
    }

    case "status": {
      if (value) {
        return {
          ...state,
          status: value,
          statusStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          status: "",
          statusStatus: "unchecked",
        };
      }
    }
    case "customerCode": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          customerCode: value,
          customerCodeStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          customerCode: "",
          customerCodeStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          customerCode: value,
          customerCodeStatus: "error",
        };
      }
    }
    case "customerCategory": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          customerCategory: value,
          customerCategoryStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          customerCategory: "",
          customerCategoryStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          customerCategory: value,
          customerCategoryStatus: "error",
        };
      }
    }

    // credit limit

    case "creditLimit": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          creditLimit: value,
          creditLimitStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          creditLimit: "",
          creditLimitStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          creditLimit: value,
          creditLimitStatus: "error",
        };
      }
    }

    // credit period
    case "creditPeriod": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          creditPeriod: value,
          creditPeriodStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          creditPeriod: "",
          creditPeriodStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          creditPeriod: value,
          creditPeriodStatus: "error",
        };
      }
    }

    //balance

    case "Balance": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          Balance: value,
          BalanceStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          Balance: "",
          BalanceStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          Balance: value,
          BalanceStatus: "error",
        };
      }
    }

    case "customerName": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          customerName: value,
          customerNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          customerName: "",
          customerNameStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          customerName: value,
          customerNameStatus: "error",
        };
      }
    }

    case "priceCode": {
      if (value) {
        return {
          ...state,
          priceCode: value,
          priceCodeStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          priceCode: "",
          priceCodeStatus: "unchecked",
        };
      }
    }
    case "repName": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          repName: value,
          repNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          repName: "",
          repNameStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          repName: value,
          repNameStatus: "error",
        };
      }
    }

    default:
      return state;
  }
};
